import { render, staticRenderFns } from "./invoice-tab-pane-add.vue?vue&type=template&id=23a9188e"
import script from "./invoice-tab-pane-add.vue?vue&type=script&lang=js"
export * from "./invoice-tab-pane-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_fa4cvkteopfvx2274rwhhr2idm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports